var StoreLocator;
(function (StoreLocator) {
    const mapsURI = 'https://maps.googleapis.com/maps/api';
    const imageUri = '/themes/custom/cactus/static/images';
    const attributesDictionary = {
        payment: 1,
        services: 2,
        departments: 3,
        online: 4,
    };
    document.addEventListener('ControllerReady', () => {
        const $storeLocator = document.querySelector('.school-book-locator');
        let isMobile = window.innerWidth < 992; 
        const italy = {
            bounds: {
                south: 35.4897,
                west: 6.6267201,
                north: 47.092,
                east: 18.7975999,
            },
            location: { lat: 41.87194, lng: 12.56738 },
            location_type: 'APPROXIMATE',
            viewport: {
                south: 35.4897,
                west: 6.6267201,
                north: 47.092,
                east: 18.7975999,
            },
        };
        const config = retrieveConfig($storeLocator);
        const gAPI = config.config.gApi;
        const script = document.createElement('script');
        script.src = `${mapsURI}/js?key=${gAPI}&callback=getAllStores&language=it&region=IT&libraries=places`;
        script.defer = true;
        script.async = true;
        document.head.appendChild(script);
        const getAllStoresEndpoint = `/api/esb/storelocator/getStoresLocation`;
        const getStoreSearchEndpoint = `/api/esb/storelocator/searchStores?_format=form`;
        const getServicesEndpoint = `/api/esb/geolink/getGeoLinks?_format=form`;
        const getStoreDetailEndpoint = `/api/esb/storelocator/getStoreDetail?_format=form`;
        const getSchoolBookService = config.config.SchoolBookService;
        let filtersResponse = [];
        let serviceResponse = [];
        let allStoresResponse = [];
        let allStoreResultsObject = {};
        let allStoreIdArray = [];
        let searchStoreResponse = [];
        let storeResultsObject = {};
        let storeIdArray = [];
        let voucher;
        let store;
        let storeGeo;
        let favouriteShops;
        localforage.getItem('favourite_store').then(shops => {
            favouriteShops = shops || [];
        });
        const searchResults = $storeLocator.querySelector('.search-results');
        const resultsCount = searchResults
            .querySelector('.results-count')
            .querySelector('.title');
        const resultsList = searchResults.querySelector('.results-list');
        const locatorSearchCardDummy = resultsList.querySelector('.locator-search-card.dummy');
        const locatorSearchCardWrapper = resultsList.querySelector('.locator-search-card-wrapper');
        const locatorSearchCardWrapperCloseToMe = searchResults.querySelector('.locator-search-card.close-to-me');
        const onlineSearchCardDummy = resultsList.querySelector('.card-shop-near.dummy');
        const onlineSearchCardWrapper = resultsList.querySelector('.online-search-card-wrapper');
        const onlineSearchSpidWrapper = resultsList.querySelector('.online-search-spid-wrapper');
        const onlineSearchCardContainer = onlineSearchCardWrapper.querySelector('.slide-container');
        const backToResults = resultsList.querySelector('.back-to-results');
        let tailSelectArray = [];
        let searchKeywords;
        let searchPlaceholder = 'Cerca per città, via, CAP…';
        let geolocalize = false;
        let geoPlaceholder = 'La mia posizione';
        const $pageWrapper = $storeLocator.querySelector('.store-locator-header');
        const $searchInput = $storeLocator.querySelector('.input-box');
        const $filterBtn = $storeLocator.querySelector('.filters-button');
        const $filterWrapper = $storeLocator.querySelector('.section-tail-select');
        const $filterDummy = $filterWrapper.querySelector('.dummy');
        const $searchBtn = $storeLocator.querySelector('.input-search-icon');
        const $resultsWrapper = $storeLocator.querySelector('.search-results');
        const $resultsWindow = $storeLocator.querySelector('.results-count');
        const $closeFilterMobile = $storeLocator.querySelector('.close-filter');
        const $geolocalization = $storeLocator.querySelector('.icn-geo');
        const $noResults = $storeLocator.querySelector('.locator-search-card-no-results');
        const $clearSearch = $storeLocator.querySelector('.clear-search');
        const $closeSearch = $storeLocator.querySelector('.input-location .cancel-button');
        const $resetFilter = $storeLocator.querySelector('.filter-header .cancel-button');
        const $hintDummy = $storeLocator.querySelector('.search-section-item.dummy');
        const $shopHints = $storeLocator.querySelector('#shop-hints');
        const $cityHints = $storeLocator.querySelector('#city-hints');
        function retrieveConfig($wrapper) {
            let data;
            const $form = $wrapper && $wrapper.querySelector('.ep-config');
            if ($form) {
                try {
                    const url = $form.querySelector('[name="url"]').value;
                    const config = $form.querySelector('[name="config"]').value;
                    data = {
                        url: url.replace(/\/$/, ''),
                        config: JSON.parse(config),
                    };
                }
                catch (e) {
                    console.log('Error during retrieval of configuration for current service. %s', e);
                }
            }
            return data;
        }
        const getFilters = () => {
            filtersResponse = [
                { "id": "Insegne", "label": "Insegne" },
                { "id": "Cooperative", "label": "Cooperative" },
                { "id": "Orari", "label": "Orari di apertura" },
                { "id": "Pagamento", "label": "Metodi di pagamento accettati" },
                { "id": "Reparti", "label": "Reparti" },
                { "id": "Servizi", "label": "Servizi" },
                { "id": "Distanza", "label": "Distanza" }
            ];
            populateFiltersOptions();
            for (let i = 0; i < filtersResponse.length; i++) {
                const currentFilterObj = filtersResponse[i];
                const currentFilterElement = $filterDummy.cloneNode(true);
                const currentFilterSelect = currentFilterElement.querySelector('select');
                currentFilterElement.classList.remove('dummy');
                currentFilterSelect.id = currentFilterObj.id;
                currentFilterSelect.setAttribute('data-placeholder', currentFilterObj.label);
                $filterWrapper.appendChild(currentFilterElement);
            }
            tailSelectArray = tail.select('select:not(#Distanza)', {
                hideSelected: false,
                hideDisabled: true,
                multiShowCount: true,
                multiSelectAll: true,
                placeholder: 'Seleziona un elemento',
            });
            tailSelectArray.push(tail.select('select#Distanza', {
                hideSelected: false,
                hideDisabled: true,
                multiShowCount: true,
                multiSelectAll: false,
                multiple: false,
                deselect: true,
                stayOpen: true,
                placeholder: 'Seleziona un elemento',
            }));
            loadFilterButtons();
        };
        const populateFiltersOptions = () => {
            const $buttonApply = $storeLocator.querySelector('.apply');
            if ($buttonApply) {
                $buttonApply.remove();
            }
            const scheduleOptionsObj = {
                O1: { value: 'Aperto ora' },
                O2: { value: 'Aperto dopo le 20' },
                O3: { value: 'Aperto di domenica' },
            };
            const distanceOptionsObj = {
                O1: { value: 'minore di 1 km' },
                O2: { value: 'minore di 5 km' },
                O3: { value: 'minore di 10 km' },
            };
            let cooperativeOptionsObj = {};
            let typeOptionsObj = {};
            let servicesOptionsObj = {};
            let departmentsOptionsObj = {};
            let paymentMethodsOptionsObj = {};
            searchStoreResponse.forEach(store => {
                var _a, _b;
                cooperativeOptionsObj[store.cooperativa.toString()] = {
                    value: store.cooperativa
                        .toString()
                        .split('_')
                        .map((word) => {
                        return word.charAt(0) + word.substr(1);
                    })
                        .join(' '),
                };
                typeOptionsObj[(_a = store.flagType) === null || _a === void 0 ? void 0 : _a.id.toString()] = {
                    value: (_b = store.flagType) === null || _b === void 0 ? void 0 : _b.value.toString(),
                };
                store.attributes.forEach(attr => {
                    attr.services.forEach(service => {
                        if (attr.type.id === attributesDictionary['services']) {
                            servicesOptionsObj[service.id.toString()] = {
                                value: service.description,
                            };
                        }
                        else if (attr.type.id === attributesDictionary['payment']) {
                            paymentMethodsOptionsObj[service.id.toString()] = {
                                value: service.description,
                            };
                        }
                        else if (attr.type.id === attributesDictionary['departments']) {
                            departmentsOptionsObj[service.id.toString()] = {
                                value: service.description,
                            };
                        }
                    });
                });
            });
            filtersResponse.forEach(filter => {
                switch (filter.id) {
                    case 'Orari':
                        let selectOrari = tailSelectArray.find(select => {
                            return select.e.id === 'Orari';
                        });
                        if (selectOrari) {
                            selectOrari.options.add(scheduleOptionsObj, null, null, null, null, null, true);
                        }
                        break;
                    case 'Cooperative':
                        let selectCooperative = tailSelectArray.find(select => {
                            return select.e.id === 'Cooperative';
                        });
                        if (selectCooperative) {
                            selectCooperative.options.items['#'] = {};
                            selectCooperative.options.add(cooperativeOptionsObj, null, null, null, null, null, true);
                        }
                        break;
                    case 'Servizi':
                        let selectServices = tailSelectArray.find(select => {
                            return select.e.id === 'Servizi';
                        });
                        if (selectServices) {
                            selectServices.options.items['#'] = {};
                            selectServices.options.add(servicesOptionsObj, null, null, null, null, null, true);
                        }
                        break;
                    case 'Reparti':
                        let selectDepartments = tailSelectArray.find(select => {
                            return select.e.id === 'Reparti';
                        });
                        if (selectDepartments) {
                            selectDepartments.options.items['#'] = {};
                            selectDepartments.options.add(departmentsOptionsObj, null, null, null, null, null, true);
                        }
                        break;
                    case 'Insegne':
                        let selectType = tailSelectArray.find(select => {
                            return select.e.id === 'Insegne';
                        });
                        if (selectType) {
                            selectType.options.items['#'] = {};
                            selectType.options.add(typeOptionsObj, null, null, null, null, null, true);
                        }
                        break;
                    case 'Pagamento':
                        let selectPaymentMethods = tailSelectArray.find(select => {
                            return select.e.id === 'Pagamento';
                        });
                        if (selectPaymentMethods) {
                            selectPaymentMethods.options.items['#'] = {};
                            selectPaymentMethods.options.add(paymentMethodsOptionsObj, null, null, null, null, null, true);
                        }
                        break;
                    case 'Distanza':
                        let selectDistance = tailSelectArray.find(select => {
                            return select.e.id === 'Distanza';
                        });
                        if (selectDistance) {
                            selectDistance.options.add(distanceOptionsObj, null, null, null, null, null, true);
                        }
                        break;
                }
            });
            loadFilterButtons();
        };
        function loadFilterButtons() {
            let button = document.createElement('button');
            button.innerText = 'Applica';
            button.classList.add('btn', 'btn-secondary', 'apply');
            document.querySelectorAll('.dropdown-inner').forEach(dropdown => {
                dropdown.insertAdjacentHTML('beforeend', button.outerHTML);
            });
            const $applyFilterButtons = $storeLocator.querySelectorAll('.apply');
            $applyFilterButtons.forEach((element, index) => {
                element.addEventListener('click', () => {
                    const tailInstance = tailSelectArray[index - 1];
                    if (tailInstance.options.selected &&
                        tailInstance.options.selected.length) {
                        tailInstance.select.classList.add('selected');
                    }
                    else {
                        tailInstance.select.classList.remove('selected');
                    }
                    updateFilterCount();
                    applyFilters();
                });
            });
        }
        function initUI() {
            getFilters();
            $searchInput.addEventListener('focus', () => {
                if (geolocalize) {
                    setGeolocalization(false);
                }
            });
            $searchInput.addEventListener('click', () => {
                if ($searchInput.value.length >= 3) {
                    changeState('search');
                    searchStoresHint($searchInput.value);
                    searchCitiesHint($searchInput.value);
                }
            });
            $searchInput.addEventListener('keyup', event => {
                if (event.keyCode === 13) {
                    if ($searchInput.value.length >= 2) {
                        searchKeywords = $searchInput.value.replace(/[^\w\s]/gi, '');
                        resetFilters();
                        searchStores();
                    }
                    else {
                        searchKeywords = null;
                        getAllStores();
                        changeState('init');
                    }
                }
                else if (event.keyCode === 27) {
                    changeState('init');
                }
                else if ($searchInput.value.length >= 3) {
                    changeState('search');
                    searchStoresHint($searchInput.value);
                    searchCitiesHint($searchInput.value);
                }
                else {
                    changeState('init');
                }
            });
            $geolocalization.addEventListener('click', () => {
                resetFilters();
                if (!geolocalize) {
                    setGeolocalization(true);
                }
                else {
                    setGeolocalization(false);
                }
            });
            $clearSearch.addEventListener('click', () => {
                $searchInput.value = '';
                changeState('init');
                getAllStores();
            });
            $searchBtn.addEventListener('click', () => {
                if ($searchInput.value.length >= 3) {
                    searchKeywords = $searchInput.value.replace(/[^\w\s]/gi, '');
                    searchStores();
                }
                else {
                    searchKeywords = null;
                    getAllStores();
                }
            });
            $filterBtn.addEventListener('click', () => {
                const disabled = $filterBtn.getAttribute('data-disabled');
                if (disabled === 'false') {
                    changeState('filter');
                }
            });
            $resultsWindow.addEventListener('click', (e) => {
                e.preventDefault();
                $pageWrapper.classList.toggle('shops');
                $resultsWrapper.classList.toggle('active');
            }, true);
            $closeFilterMobile.addEventListener('click', () => {
                changeState('filter');
            });
            $closeSearch.addEventListener('click', () => {
                changeState('init');
            });
            $resetFilter.addEventListener('click', () => {
                changeState('filter');
                resetFilters(true);
            });
        }
        const setGeolocalization = setState => {
            if (setState) {
                geolocalize = true;
                searchKeywords = null;
                $searchInput.value = '';
                $searchInput.placeholder = geoPlaceholder;
                $geolocalization.classList.add('active');
                $resultsWrapper.classList.add('has-card');
                searchStores();
            }
            else {
                geolocalize = false;
                $searchInput.placeholder = searchPlaceholder;
                $geolocalization.classList.remove('active');
                $resultsWrapper.classList.remove('has-card');
            }
        };
        const resetFilters = (reload = false) => {
            for (let i = 0; i < tailSelectArray.length; i++) {
                const tailInstance = tailSelectArray[i];
                tailInstance.options.all('unselect');
                tailInstance.select.classList.remove('selected');
            }
            updateFilterCount();
            if (reload) {
                searchStores();
            }
        };
        const updateFilterCount = () => {
            const $filtersCount = $storeLocator.querySelector('.filter-count');
            let selectedCount = 0;
            for (let i = 0; i < tailSelectArray.length; i++) {
                const tailInstance = tailSelectArray[i];
                if (tailInstance.options.selected &&
                    tailInstance.options.selected.length) {
                    selectedCount++;
                }
                tailInstance.close(true);
            }
            $filtersCount.innerHTML = selectedCount.toString();
            if (selectedCount) {
                $filtersCount.classList.remove('no-filter');
            }
            else {
                $filtersCount.classList.add('no-filter');
            }
        };
        function changeState(state) {
            const $pageWrapper = $storeLocator.querySelector('.store-locator-header');
            const $searchBar = $storeLocator.querySelector('.input-location');
            const $filterBtn = $storeLocator.querySelector('.filters-button');
            const $filterBar = $storeLocator.querySelector('.filter-bar');
            const $resultsWrapper = $storeLocator.querySelector('.search-results');
            const $clearSearch = document.querySelector('.clear-search');
            const $geolocalization = $storeLocator.querySelector('.icn-geo');
            switch (state) {
                case 'init':
                    $pageWrapper.classList.remove('search', 'filter', 'shops');
                    $searchBar.classList.remove('active');
                    $filterBtn.setAttribute('data-disabled', true);
                    $filterBtn.classList.remove('active');
                    $filterBar.classList.remove('active');
                    $clearSearch.classList.remove('show');
                    $geolocalization.classList.remove('active');
                    break;
                case 'search':
                    $pageWrapper.classList.add('search');
                    $pageWrapper.classList.remove('filter');
                    $filterBtn.classList.remove('active');
                    $filterBar.classList.remove('active');
                    $searchBar.classList.add('active');
                    break;
                case 'filter':
                    $pageWrapper.classList.toggle('filter');
                    $filterBtn.classList.toggle('active');
                    $filterBar.classList.toggle('active');
                    $searchBar.classList.remove('active');
                    break;
                case 'show-result':
                    $pageWrapper.classList.remove('search');
                    $searchBar.classList.remove('active');
                    $resultsWrapper.classList.remove('hidden');
                    $clearSearch.classList.add('show');
                    $filterBtn.setAttribute('data-disabled', false);
                    $noResults.classList.add('hidden');
                    break;
                case 'show-error':
                    $pageWrapper.classList.add('shops');
                    $resultsWrapper.classList.add('active');
                    $noResults.classList.remove('hidden');
                    break;
            }
        }
        let markerClusterer = null;
        let map = null;
        let imageUrl = `${imageUri}/pin.png`;
        let imageCoopUrl = `${imageUri}/pin-coop.png`;
        let styles = [
            MarkerClusterer.withDefaultStyle({
                width: 35,
                height: 35,
                url: `${imageUri}/pin-cluster-35.png`,
                textColor: '#ffffff',
                textSize: 10,
            }),
            MarkerClusterer.withDefaultStyle({
                width: 45,
                height: 45,
                url: `${imageUri}/pin-cluster-45.png`,
                textColor: '#ffffff',
                textSize: 11,
            }),
            MarkerClusterer.withDefaultStyle({
                width: 55,
                height: 55,
                url: `${imageUri}/pin-cluster-55.png`,
                textColor: '#ffffff',
                textSize: 12,
            }),
        ];
        const initMap = () => {
            centerAddress({
                latitude: italy.location.lat,
                longitude: italy.location.lng,
            }, isMobile ? 5 : 6, allStoresResponse);
            clearResults();
        };
        const refreshMarkers = (markersList, id) => {
            if (markerClusterer) {
                markerClusterer.clearMarkers();
            }
            var markerImage = new google.maps.MarkerImage(imageUrl, new google.maps.Size(35, 35));
            var markerCoopImage = new google.maps.MarkerImage(imageCoopUrl, new google.maps.Size(55, 55));
            let markersArray = [];
            if (markersList instanceof Array) {
                markersArray = markersList;
            }
            else {
                markersArray = Object.keys(markersList).map(markerId => {
                    return markersList[markerId];
                });
            }
            var markers = markersArray.reduce((acc, store) => {
                var _a, _b;
                if (((_a = store.geo) === null || _a === void 0 ? void 0 : _a.latitude) && ((_b = store.geo) === null || _b === void 0 ? void 0 : _b.longitude)) {
                    let newMarker = new google.maps.Marker({
                        position: {
                            lat: store.geo.latitude,
                            lng: store.geo.longitude,
                        },
                        icon: store.id === id ? markerCoopImage : markerImage,
                        storeId: store.id,
                    });
                    newMarker.addListener('click', function () {
                        centerMap(newMarker.storeId);
                        if (!storeIdArray || !storeIdArray.length) {
                            setSingleStoreResult(newMarker.storeId);
                        }
                        selectStore(newMarker.storeId);
                    });
                    acc.push(newMarker);
                }
                return acc;
            }, []);
            markerClusterer = new MarkerClusterer(map, markers, {
                styles: styles,
            });
        };
        function centerAddress(coords, zoomValue = isMobile ? 5 : 6, markersList = allStoresResponse) {
            map = new google.maps.Map(document.getElementById('map'), {
                zoom: zoomValue,
                center: { lat: coords.latitude, lng: coords.longitude },
                disableDefaultUI: true,
                zoomControl: true,
                gestureHandling: "none",
                minZoom: zoomValue - 3,
                disableDoubleClickZoom: true,
                styles: [{ featureType: "poi", elementType: "labels", stylers: [{ visibility: "off" }] }]
            });
            refreshMarkers(markersList);
        }
        function centerMap(id, zoomValue = isMobile ? 14 : 15) {
            const storeResults = storeIdArray && storeIdArray.length
                ? storeResultsObject
                : allStoreResultsObject;
            const store = storeResults[id];
            map = new google.maps.Map(document.getElementById('map'), {
                zoom: zoomValue,
                center: {
                    lat: store.geo.latitude,
                    lng: store.geo.longitude,
                },
                disableDefaultUI: true,
                zoomControl: true,
                gestureHandling: "none"
            });
            refreshMarkers(storeResults, id);
        }
        const getStoreDetail = storeId => {
            return new Promise((resolve, reject) => {
                if (allStoreResultsObject[storeId].attributes || allStoreResultsObject[storeId].schedules) {
                    resolve(allStoreResultsObject[storeId]);
                }
                else {
                    return Fetch(getStoreDetailEndpoint, {
                        method: 'POST',
                        data: { storeId: [storeId] },
                        token: { enable: true }
                    }).then(rawStoreDetailResponse => {
                        store = rawStoreDetailResponse.payload.stores[0];
                        allStoreResultsObject[storeId] = store;
                        storeGeo = store.geo;
                        resolve(store);
                    }).catch((err) => {
                        _flog(0, err, {
                            url: getStoreDetailEndpoint,
                            data: { storeId: [storeId] },
                        }, {});
                    });
                }
            });
        };
        function normalizeDistance(distance) {
            let normDistance;
            if (distance > 1000) {
                normDistance = (distance / 1000).toFixed(1) + ' km';
            }
            else {
                normDistance = distance + ' m';
            }
            return normDistance;
        }
        function getCheckDay(store, checkDate = new Date()) {
            const extraordinary = store.extraordinary_schedule &&
                store.extraordinary_schedule.find(extraDay => {
                    let extraDayTime = new Date(extraDay.date);
                    return (extraDayTime.getFullYear() +
                        '/' +
                        extraDayTime.getMonth() +
                        '/' +
                        extraDayTime.getDate() ===
                        checkDate.getFullYear() +
                            '/' +
                            checkDate.getMonth() +
                            '/' +
                            checkDate.getDate());
                });
            const ordinary = store.schedules &&
                store.schedules.find(ordDay => {
                    return checkDate.getDay() + 1 === ordDay.dayOfTheWeek;
                });
            return extraordinary || ordinary;
        }
        const checkDaySchedue = checkDay => {
            const now = new Date();
            let scheduleText = 'Chiuso';
            let searchNextDay = false;
            let isOpen = false;
            if (checkDay && checkDay.status) {
                let daySegments = checkDay.value.split(';').map(segment => {
                    return segment.split('-');
                });
                let afterSegments = [];
                daySegments.forEach((segment, index) => {
                    let startDate = new Date();
                    startDate.setHours(segment[0].split(':')[0]);
                    startDate.setMinutes(segment[0].split(':')[1]);
                    startDate.setSeconds(0);
                    let endDate = new Date();
                    endDate.setHours(segment[1].split(':')[0]);
                    endDate.setMinutes(segment[1].split(':')[1]);
                    endDate.setSeconds(0);
                    afterSegments[index] = now > endDate;
                    if (now >= startDate && now <= endDate) {
                        isOpen = true;
                        scheduleText = 'Aperto ora - Chiusura: ' + segment[1];
                    }
                });
                if (!isOpen) {
                    let segmentIndex = afterSegments.indexOf(false);
                    if (segmentIndex > 0) {
                        scheduleText +=
                            ' - Apertura: ' + daySegments[segmentIndex][0];
                    }
                    else {
                        searchNextDay = true;
                    }
                }
            }
            else {
                searchNextDay = true;
            }
            return {
                isOpen: isOpen,
                searchNextDay: searchNextDay,
                scheduleText: scheduleText,
            };
        };
        const checkOpenUntill = (checkDay, checkDate) => {
            if (checkDay && checkDay.status) {
                let daySegments = checkDay.value.split(';').map(segment => {
                    return segment.split('-');
                });
                let segmentFound = daySegments.find(segment => {
                    let endDate = new Date();
                    endDate.setHours(segment[1].split(':')[0]);
                    endDate.setMinutes(segment[1].split(':')[1]);
                    endDate.setSeconds(0);
                    return checkDate <= endDate;
                });
                return !!segmentFound;
            }
            else {
                return false;
            }
        };
        function getSchedule(store) {
            const now = moment();
            const currDay = now.day();
            const days = ['', 'Lunedi', 'Martedi', 'Mercoledi', 'Giovedi', 'Venerdi', 'Sabato', 'Domenica'];
            let status = '';
            if (store) {
                store.extraordinary_schedules.forEach((schedule) => {
                    const date = normalizeDate(moment(schedule.date));
                    if (normalizeDate(now).isSame(date)) {
                        if (schedule.status) {
                            const timeFragment = evaluateTimeFragment(schedule.value, now.format('HH:mm'));
                            if (timeFragment.status) {
                                status = 'Aperto Ora - Chiude alle ' + timeFragment.nextClose;
                            }
                            else {
                                if (timeFragment.nextOpen) {
                                    status = 'Chiuso ora - Apre alle ' + timeFragment.nextOpen;
                                }
                                else {
                                    const nextOpening = findNextOpening(store.schedules, currDay);
                                    status = nextOpening ? 'Chiuso ora - Apre ' + nextOpening : 'Chiuso ora';
                                }
                            }
                        }
                        else {
                            const nextOpening = findNextOpening(store.schedules, currDay);
                            status = nextOpening ? 'Chiuso ora - Apre ' + nextOpening : 'Chiuso ora';
                        }
                    }
                });
                let i, len, found, schedules;
                schedules = store.schedules;
                i = 0;
                len = schedules.length;
                while (i < len && !found) {
                    found = schedules[i].dayOfTheWeek === currDay;
                    !found && i++;
                }
                if (found) {
                    const timeFragment = evaluateTimeFragment(schedules[i].value, now.format('HH:mm'));
                    if (timeFragment.status) {
                        status = 'Aperto Ora - Chiude alle ' + timeFragment.nextClose;
                    }
                    else {
                        if (timeFragment.nextOpen) {
                            status = 'Chiuso ora - Apre alle ' + timeFragment.nextOpen;
                        }
                        else {
                            const nextOpening = findNextOpening(store.schedules, currDay);
                            status = nextOpening ? 'Chiuso ora - Apre ' + nextOpening : 'Chiuso ora';
                        }
                    }
                }
                else {
                    const nextOpening = findNextOpening(store.schedules, currDay);
                    status = nextOpening ? 'Chiuso ora - Apre ' + nextOpening : '';
                }
            }
            function findNextOpening(schedules, day) {
                let nextOpening = '';
                let i = 0;
                let len = schedules.length;
                let found;
                if (schedules.length) {
                    while (i < len && !found) {
                        found = day < schedules[i].dayOfTheWeek;
                        !found && i++;
                    }
                    if (!found) {
                        i = 0;
                    }
                    const timeFragment = schedules[i].value.split('-')[0] || '';
                    nextOpening = `${days[schedules[i].dayOfTheWeek]} alle ${timeFragment}`;
                }
                return nextOpening;
            }
            function evaluateTimeFragment(fragment, instant) {
                let ret = {
                    status: false,
                    nextOpen: '',
                    nextClose: '',
                };
                let nextOpeningHour;
                if (fragment) {
                    const fragments = fragment.split(';');
                    let start, end, i, len, found;
                    i = 0;
                    len = fragments.length;
                    do {
                        [start, end] = fragments[i].split('-');
                        found = start <= instant && instant <= end;
                        if (instant < start && !nextOpeningHour) {
                            nextOpeningHour = start;
                        }
                        !found && i++;
                    } while (i < len && !found);
                    ret = {
                        status: i < len,
                        nextOpen: nextOpeningHour || '',
                        nextClose: end
                    };
                }
                return ret;
            }
            function normalizeDate(date) {
                date = date || moment();
                date = date.clone();
                date.hours(0);
                date.minutes(0);
                date.seconds(0);
                date.milliseconds(0);
                return date;
            }
            return status;
        }
        const populateStoreDatas = (storeElement, storeObj) => {
            var _a;
            storeElement.classList.remove('dummy', 'hidden');
            storeElement.setAttribute('data-store-id', storeObj.id);
            let redirect = false;
            if (storeLocatorRedirects) {
                redirect = storeLocatorRedirects.find(el => el.id === storeObj.id.toString());
            }
            if (redirect && redirect.url) {
                storeElement.querySelectorAll('a').forEach(($link) => {
                    $link.href = redirect.url;
                    $link.target = '_blank';
                });
            }
            else {
                storeElement.querySelectorAll('a').forEach(($link) => {
                    $link.href = `/spesa-e-servizi/punti-vendita/${storeObj.id.toString()}/${storeObj.name.replace(/[^a-zA-Z0-9\s\-_]/gmi, '').replace(/\s/gmi, '-')}`;
                });
            }
            storeElement.querySelector('.shop-name').innerHTML = storeObj.name;
            storeElement.querySelector('.shop-address').innerHTML =
                storeObj.address || '';
            storeElement.querySelector('.shop-type').innerHTML =
                (((_a = storeObj.flagType) === null || _a === void 0 ? void 0 : _a.value) || '');
            if (storeObj.logo) {
                storeElement.querySelector('.logo-img').setAttribute('src', storeObj.logo);
                storeElement.querySelector('.logo-img').setAttribute('alt', 'logo');
            }
            if (storeObj.distance) {
                storeElement
                    .querySelector('.shop-distance')
                    .classList.remove('hidden');
                storeElement.querySelector('.shop-distance').innerHTML =
                    normalizeDistance(storeObj.distance) +
                        ' - ' +
                        storeObj.city;
            }
            else {
                storeElement
                    .querySelector('.shop-distance')
                    .classList.add('hidden');
            }
            storeElement.querySelector('.shop-hours').innerHTML = getSchedule(storeObj);
            if (storeObj.logo) {
                storeElement.querySelector('.logo-img').src = storeObj.logo;
            }
            if (favouriteShops) {
                let storeFound = favouriteShops.find(store => {
                    return store.id === storeObj.id;
                });
                if (storeFound) {
                    storeElement
                        .querySelector('.favourite-shop')
                        .classList.add('is-favourite');
                }
            }
            storeElement.addEventListener('click', () => {
                centerMap(storeObj.id);
                selectStore(storeObj.id);
                if (isMobile) {
                    $pageWrapper.classList.toggle('shops');
                    $resultsWrapper.classList.toggle('active');
                }
            });
            const $favouriteBtn = storeElement.querySelector('.favourite-shop');
            $favouriteBtn.addEventListener('click', evt => {
                evt.preventDefault();
                evt.stopPropagation();
                $favouriteBtn.classList.toggle('is-favourite');
                toggleFavouriteShop(storeObj);
            });
            if (storeObj.linkPrenotazioneLibri) {
                storeElement.querySelector('.online-search-spid-wrapper').classList.remove('hidden');
                const $spidBtn = storeElement.querySelector('.online-search-spid-wrapper');
                $spidBtn.addEventListener('click', evt => {
                    evt.preventDefault();
                    backToResults.classList.add('hidden');
                    $storeLocator.setAttribute('data-spinner', 'mask');
                    const $body = document.querySelector('body');
                    const $modal = document.querySelector('.school-book-modal');
                    const $btnAccept = $modal.querySelector('.accept');
                    const $btnNoAccept = $modal.querySelector('.no-accept');
                    $modal.classList.remove('d-none');
                    $body.classList.add('scrollLock');
                    $btnAccept.removeEventListener('click', () => { });
                    $btnAccept.addEventListener('click', () => {
                        window.open(storeObj.linkPrenotazioneLibri, 'New Window');
                        $modal.classList.add('d-none');
                        $body.classList.remove('scrollLock');
                    });
                    $btnNoAccept.removeEventListener('click', () => { });
                    $btnNoAccept.addEventListener('click', () => {
                        $modal.classList.add('d-none');
                        $body.classList.remove('scrollLock');
                    });
                    $storeLocator.removeAttribute('data-spinner');
                });
            }
        };
        const toggleFavouriteShop = storeObj => {
            localforage.getItem('favourite_store').then(shops => {
                if (shops) {
                    let storeFound = shops.find(store => {
                        return store.id === storeObj.id;
                    });
                    if (storeFound) {
                        let newStores = shops.filter(store => {
                            return store.id !== storeObj.id;
                        });
                        shops = newStores;
                    }
                    else {
                        shops.push(storeObj);
                    }
                    localforage.setItem('favourite_store', shops);
                    favouriteShops = shops;
                }
                else {
                    let shops = [storeObj];
                    localforage.setItem('favourite_store', shops);
                    favouriteShops = shops;
                }
            });
        };
        const setSingleStoreResult = storeId => {
            locatorSearchCardWrapper.innerHTML = '';
            locatorSearchCardWrapperCloseToMe.innerHTML = '';
            onlineSearchCardWrapper.classList.add('hidden');
            getStoreDetail(storeId).then(store => {
                let nextStore = locatorSearchCardDummy.cloneNode(true);
                populateStoreDatas(nextStore, store);
                updateResultsCount(true);
                locatorSearchCardWrapper.appendChild(nextStore);
                $pageWrapper.classList.add('shops');
                searchResults.classList.remove('hidden');
                searchResults.classList.add('active');
            });
        };
        const selectStore = storeId => {
            const locatorSearchCards = resultsList.querySelectorAll('.locator-search-card');
            for (let i = 0; i < locatorSearchCards.length; i++) {
                const store = locatorSearchCards[i];
                if (store.hasAttribute('data-store-id') &&
                    store.getAttribute('data-store-id').toString() ===
                        storeId.toString()) {
                    store.classList.remove('hidden');
                }
                else {
                    store.classList.add('hidden');
                }
            }
            $pageWrapper.classList.add('shops');
            searchResults.classList.remove('hidden');
            searchResults.classList.add('active');
            if (storeIdArray && storeIdArray.length) {
                backToResults.classList.remove('hidden');
                onlineSearchCardWrapper.classList.add('hidden');
            }
        };
        const showAllResults = () => {
            const locatorSearchCards = resultsList.querySelectorAll('.locator-search-card');
            for (let i = 0; i < locatorSearchCards.length; i++) {
                const store = locatorSearchCards[i];
                store.classList.remove('hidden');
            }
            backToResults.classList.add('hidden');
            onlineSearchCardWrapper.classList.remove('hidden');
        };
        const clearResults = () => {
            storeResultsObject = {};
            storeIdArray = [];
            backToResults.classList.add('hidden');
            onlineSearchCardWrapper.classList.add('hidden');
            updateResultsCount();
            locatorSearchCardWrapper.innerHTML = '';
            locatorSearchCardWrapperCloseToMe.innerHTML = '';
            searchResults.classList.add('hidden');
        };
        const updateResultsCount = (showAllStores = false) => {
            if (!showAllStores) {
                resultsCount.innerHTML =
                    'Trovati <b>' + storeIdArray.length + ' NEGOZI</b>';
            }
            else {
                resultsCount.innerHTML =
                    'Trovati <b>' + allStoreIdArray.length + ' NEGOZI</b>';
            }
        };
        const updateResults = () => {
            locatorSearchCardWrapper.innerHTML = '';
            locatorSearchCardWrapperCloseToMe.innerHTML = '';
            storeIdArray.forEach((store, i) => {
                let nextStore = locatorSearchCardDummy.cloneNode(true);
                populateStoreDatas(nextStore, store);
                if (i === 0) {
                    locatorSearchCardWrapperCloseToMe.appendChild(nextStore.cloneNode(true));
                }
                locatorSearchCardWrapper.appendChild(nextStore);
            });
            backToResults.addEventListener('click', () => {
                showAllResults();
            });
            searchResults.classList.remove('hidden');
        };
        const searchStoresHint = inputSearch => {
            let hintsArray = allStoresResponse
                .filter(store => {
                return store.name
                    .toLowerCase()
                    .includes(inputSearch.toLowerCase());
            })
                .slice(0, 4);
            $shopHints.innerHTML = '';
            if (hintsArray && hintsArray.length) {
                hintsArray.forEach(store => {
                    var hint = $hintDummy.cloneNode(true);
                    hint.classList.remove('dummy');
                    let formattedPrediction = getHintText(inputSearch, store.name);
                    hint.querySelector('.item-name').innerHTML = formattedPrediction;
                    hint.addEventListener('click', () => {
                        $searchInput.value = store.name;
                        searchKeywords = store.name;
                        resetFilters();
                        searchStores(store);
                    });
                    $shopHints.appendChild(hint);
                });
            }
            else {
                var hint = $hintDummy.cloneNode(true);
                hint.classList.remove('dummy');
                hint.querySelector('.icn').classList.remove('icn-search');
                hint.querySelector('.item-name').innerHTML =
                    'Nessun suggerimento trovato';
                $shopHints.appendChild(hint);
            }
        };
        const searchCitiesHint = inputSearch => {
            var service = new google.maps.places.AutocompleteService();
            service.getPlacePredictions({
                input: inputSearch,
                types: ['(cities)'],
                componentRestrictions: { country: 'it' },
            }, (predictions, status) => {
                $cityHints.innerHTML = '';
                if (status === google.maps.places.PlacesServiceStatus.OK &&
                    predictions &&
                    predictions.length) {
                    predictions.forEach(prediction => {
                        var hint = $hintDummy.cloneNode(true);
                        hint.classList.remove('dummy');
                        let formattedPrediction = getHintText(inputSearch, prediction.description);
                        hint.querySelector('.item-name').innerHTML = formattedPrediction;
                        hint.addEventListener('click', () => {
                            $searchInput.value = prediction.description;
                            searchKeywords = prediction.description;
                            resetFilters();
                            searchStores();
                        });
                        $cityHints.appendChild(hint);
                    });
                }
                else {
                    var hint = $hintDummy.cloneNode(true);
                    hint.classList.remove('dummy');
                    hint.querySelector('.icn').classList.remove('icn-search');
                    hint.querySelector('.item-name').innerHTML =
                        'Nessun suggerimento trovato';
                    $cityHints.appendChild(hint);
                }
            });
        };
        const getHintText = (searchText, hint) => {
            let startIndex = hint
                .toLowerCase()
                .indexOf(searchText.toLowerCase());
            let formattedPrediction = hint;
            if (startIndex >= 0) {
                formattedPrediction =
                    hint.substr(0, startIndex) +
                        '<b>' +
                        hint.substr(startIndex, searchText.length) +
                        '</b>' +
                        hint.substr(startIndex + searchText.length);
            }
            return formattedPrediction;
        };
        const getAllStores = () => {
            $storeLocator.setAttribute('data-spinner', 'mask');
            if (allStoresResponse && allStoresResponse.length) {
                initMap();
                $storeLocator.removeAttribute('data-spinner');
            }
            else {
                Fetch(getAllStoresEndpoint, { method: 'GET', data: { idServizio: getSchoolBookService, _format: 'form' }, token: { enable: true } })
                    .then(response => {
                    if (response.header.result === 'OK') {
                        allStoresResponse = response.payload.stores;
                        allStoresResponse.forEach(store => {
                            allStoreResultsObject[store.id] = store;
                        });
                        allStoreIdArray = Object.keys(allStoreResultsObject);
                        const urlParams = new URLSearchParams(window.location.search);
                        const query = urlParams.get('query');
                        if (query && query === 'position') {
                            setGeolocalization(true);
                        }
                        else if (query) {
                            $searchInput.value = query;
                            searchKeywords = query;
                            resetFilters();
                            searchStores();
                        }
                        else {
                            initMap();
                        }
                    }
                    else {
                        console.log('Handle error');
                    }
                })
                    .catch((err) => {
                    _flog(0, err, {
                        url: getAllStoresEndpoint,
                    }, {});
                })
                    .finally(() => {
                    $storeLocator.removeAttribute('data-spinner');
                });
            }
        };
        const getServices = body => {
            const { latitude, longitude } = body.coords;
            getZipCode({ latitude, longitude })
                .then((zipCode) => {
                return zipCode || '';
            })
                .catch(() => { }) 
                .then(zipCode => {
                Fetch(getServicesEndpoint, {
                    method: 'POST',
                    data: {
                        latitude,
                        longitude,
                        zipCode,
                        type: 'HP'
                    },
                    token: { enable: true }
                }).then(rawServicesResponse => {
                    serviceResponse = rawServicesResponse.payload.services;
                    if (serviceResponse && serviceResponse.length) {
                        onlineSearchCardContainer.innerHTML = '';
                        for (let i = 0; i < serviceResponse.length; i++) {
                            const serviceObj = serviceResponse[i];
                            let serviceElement = onlineSearchCardDummy.cloneNode(true);
                            serviceElement.classList.remove('dummy');
                            if (serviceObj.image) {
                                serviceElement.querySelector('img').src = serviceObj.image;
                            }
                            serviceElement.querySelector('.card-description').innerHTML = serviceObj.text;
                            serviceElement.querySelector('.card-link').href = serviceObj.link;
                            onlineSearchCardContainer.appendChild(serviceElement);
                        }
                        onlineSearchCardWrapper.classList.remove('empty');
                    }
                })
                    .catch((err) => {
                    _flog(0, err, {
                        url: getServicesEndpoint,
                        data: {
                            latitude,
                            longitude,
                            zipCode,
                            type: 'HP'
                        },
                    }, {});
                });
            });
        };
        const sortIdArray = (storesObj, sortKey = 'distance') => {
            return Object.values(storesObj).sort((curr, next) => {
                let ret = 0;
                if (curr[sortKey] < next[sortKey]) {
                    ret = -1;
                }
                else if (curr[sortKey] > next[sortKey]) {
                    ret = 1;
                }
                return ret;
            });
        };
        const searchStores = (store = null) => {
            let body = {
                coords: null,
                storeName: null,
            };
            $storeLocator.setAttribute('data-spinner', 'mask');
            if (store) {
                body.storeName = store.name;
                getSearchData(body);
                let coordBody = {
                    coords: store.geo,
                };
                getServices(coordBody);
            }
            else if (geolocalize) {
                getCoords()
                    .then(position => {
                    body.coords = {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                    };
                    getSearchData(body);
                    getServices(body);
                })
                    .catch(() => {
                    $storeLocator.removeAttribute('data-spinner');
                });
            }
            else {
                const geocoder = new google.maps.Geocoder();
                geocoder.geocode({
                    address: searchKeywords,
                }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        body.coords = {
                            latitude: results[0].geometry.location.lat(),
                            longitude: results[0].geometry.location.lng(),
                        };
                        getSearchData(body);
                        getServices(body);
                    }
                });
            }
        };
        const applyFilters = () => {
            storeResultsObject = {};
            searchStoreResponse.forEach(store => {
                let schoolBookService = (store.attributes ? store.attributes.find(el => el.type.description === 'Servizi' ? el.services.find(elem => elem.id == getSchoolBookService) : null) : null);
                if (schoolBookService) {
                    allStoreResultsObject[store.id] = store;
                    store.filterCheck = true;
                    tailSelectArray.forEach(filter => {
                        if (filter.options &&
                            filter.options.selected &&
                            filter.options.selected.length) {
                            switch (filter.e.id) {
                                case 'Orari':
                                    let checkSchedule = false;
                                    filter.options.selected.forEach(currSelectedFilter => {
                                        let checkDay;
                                        switch (currSelectedFilter.value) {
                                            case 'O1':
                                                checkDay = getCheckDay(store);
                                                let checkDayResult = checkDaySchedue(checkDay);
                                                checkSchedule =
                                                    checkSchedule ||
                                                        checkDayResult.isOpen;
                                                break;
                                            case 'O2':
                                                checkDay = getCheckDay(store);
                                                let checkDate = new Date();
                                                checkDate.setHours(20);
                                                checkDate.setMinutes(1);
                                                checkDate.setSeconds(0);
                                                let checkOpenUntillResult = checkOpenUntill(checkDay, checkDate);
                                                checkSchedule = checkSchedule || !!checkOpenUntillResult;
                                                break;
                                            case 'O3':
                                                let today = new Date();
                                                let nextSunday = today;
                                                if (today.getDay() !== 0) {
                                                    let dayOffset = (6 - today.getDay()) % 6;
                                                    nextSunday.setDate(nextSunday.getDate() + dayOffset);
                                                }
                                                checkDay = getCheckDay(store, nextSunday);
                                                checkSchedule = checkSchedule || (checkDay && checkDay.status);
                                                break;
                                        }
                                    });
                                    store.filterCheck =
                                        store.filterCheck && !!checkSchedule;
                                    break;
                                case 'Cooperative':
                                    let checkCooperative = filter.options.selected.find(currSelectedFilter => {
                                        return (store.cooperativa.toString() ===
                                            currSelectedFilter.value.toString());
                                    });
                                    store.filterCheck =
                                        store.filterCheck && !!checkCooperative;
                                    break;
                                case 'Servizi':
                                    store.filterCheck =
                                        store.filterCheck &&
                                            attributesMatch(filter, store.attributes, 'services');
                                    break;
                                case 'Reparti':
                                    store.filterCheck =
                                        store.filterCheck &&
                                            attributesMatch(filter, store.attributes, 'departments');
                                    break;
                                case 'Insegne':
                                    let checkFlagType = filter.options.selected.find(currSelectedFilter => {
                                        return (store.flagType && store.flagType.id.toString() ===
                                            currSelectedFilter.value.toString());
                                    });
                                    store.filterCheck =
                                        store.filterCheck && !!checkFlagType;
                                    break;
                                case 'Pagamento':
                                    store.filterCheck =
                                        store.filterCheck &&
                                            attributesMatch(filter, store.attributes, 'payment');
                                    break;
                                case 'Distanza':
                                    let checkDistance = false;
                                    filter.options.selected.forEach(currSelectedFilter => {
                                        switch (currSelectedFilter.value) {
                                            case 'O1':
                                                checkDistance = store.distance < 1000; 
                                                break;
                                            case 'O2':
                                                checkDistance = store.distance < 5000; 
                                                break;
                                            case 'O3':
                                                checkDistance = store.distance < 10000; 
                                                break;
                                            default:
                                                checkDistance = true;
                                        }
                                    });
                                    store.filterCheck = store.filterCheck && checkDistance;
                                    break;
                            }
                        }
                    });
                    if (store.filterCheck) {
                        storeResultsObject[store.id] = store;
                    }
                }
            });
            storeIdArray = sortIdArray(storeResultsObject);
            refreshMarkers(storeResultsObject);
            updateResultsCount();
            updateResults();
            if (storeIdArray && storeIdArray.length) {
                changeState('show-result');
            }
            else {
                changeState('show-error');
            }
        };
        function attributesMatch(filter, attrs, category) {
            let filterValues = filter.options.selected.map(f => f.value);
            let storeAttrs = attrs.filter(attr => attr.type.id === attributesDictionary[category]);
            let i = 0, len = storeAttrs.length, found = false;
            while (i < len && !found) {
                let services = storeAttrs[i].services;
                let j = 0, lenj = services.length;
                while (j < lenj && !found) {
                    found = filterValues.some(el => el === services[j].id.toString());
                    j++;
                }
                i++;
            }
            return found;
        }
        function hideEmptySelects() {
            const $selects = document.querySelectorAll('.wrapper-select:not(.dummy)');
            $selects.forEach($s => {
                $s.classList.remove('hidden');
            });
            [].slice
                .call($selects)
                .filter($s => !$s.querySelectorAll('option').length)
                .forEach($s => {
                $s.classList.add('hidden');
            });
        }
        const getSearchData = body => {
            Fetch(getStoreSearchEndpoint, {
                method: 'POST',
                data: body,
                token: { enable: true }
            })
                .then(rawSearchStoresResponse => {
                searchStoreResponse =
                    rawSearchStoresResponse.payload.stores;
                populateFiltersOptions();
                hideEmptySelects();
                centerAddress(body.coords || searchStoreResponse[0].geo, isMobile ? 12 : 13, []);
                applyFilters();
                onlineSearchCardWrapper.classList.remove('hidden');
            })
                .catch((err) => {
                _flog(0, err, {
                    url: getStoreSearchEndpoint,
                }, {});
            })
                .finally(() => {
                $storeLocator.removeAttribute('data-spinner');
            });
        };
        initUI();
        window.addEventListener('resize', () => {
            isMobile = window.innerWidth < 992;
        });
        $storeLocator.querySelector('.input-content').addEventListener('click', () => {
            if (location.search) {
                let value = $searchInput.value.replace(/[^a-zA-Z0-9\s\-_]/gim, '').replace(/\s/gim, '+');
                history.pushState({}, '', location.href.replace(location.search, `?query=${value}`));
            }
        });
        $searchInput.addEventListener('keyup', event => {
            if (event.keyCode === 13 && location.search) {
                let value = $searchInput.value.replace(/[^a-zA-Z0-9\s\-_]/gim, '').replace(/\s/gim, '+');
                history.pushState({}, '', location.href.replace(location.search, `?query=${value}`));
            }
        });
        document.body.addEventListener("touchstart", ev => {
            ev.stopImmediatePropagation();
        }, { passive: true });
        document.body.addEventListener("touchend", ev => {
            ev.stopImmediatePropagation();
        }, { passive: true });
        publish(getAllStores, 'getAllStores');
    });
})(StoreLocator || (StoreLocator = {}));
